import React from 'react';
import uniqid from 'uniqid';

interface IErrorMessage {
  message: string;
}

interface IErrorMessages {
  errors: IErrorMessage[];
}

const ErrorMessages: React.FC<IErrorMessages> = ({ errors = [] }) => (
  <>
    {!!errors.length &&
      errors.map(error => (
        <p key={uniqid()} className="f7 serif i red mt1 mb0 lh-copy">
          {error.message}
        </p>
      ))}
  </>
);

export default ErrorMessages;
